import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SortEvent } from 'primeng/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class CommonService<E> {

  protected http = inject(HttpClient);

  protected endpoint!: string;

  protected headers: HttpHeaders = new HttpHeaders(
    { 'Content-Type': 'application/json' }
  );

  public findAll(page: number, size: number, sort?: SortEvent): Observable<any> {
    const params = !sort
      ? new HttpParams().set('page', page).set('size', size)
      : new HttpParams().set('page', page).set('size', size).set('sort', `${sort.field},${sort.order === 1 ? 'asc' : 'desc'}`);
    return this.http.get<E[]>(this.endpoint, { params: params });
  }

  public findById(id: number | string): Observable<E> {
    return this.http.get<E>(`${this.endpoint}/${id}`)
  }

  public save(e: E, params?: HttpParams): Observable<E> {
    if (params) return this.http.post<E>(this.endpoint, e, { headers: this.headers, params: params });
    return this.http.post<E>(this.endpoint, e, { headers: this.headers });
  }

  public update(id: number | string, e: E, params?: HttpParams): Observable<E> {
    if (params) return this.http.put<E>(`${this.endpoint}/${id}`, e, { headers: this.headers, params: params })
    return this.http.put<E>(`${this.endpoint}/${id}`, e, { headers: this.headers })
  }

  public delete(id: number | string): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${id}`);
  }

  public filterAll(term: string): Observable<E[]> {
    const params = new HttpParams().set('term', term);
    return this.http.get<E[]>(`${this.endpoint}/filter/all`, { params: params});
  }

  public filterWithPageable(term: string, page: number, size: number, sort?: SortEvent): Observable<any> {
    const params = !sort
      ? new HttpParams().set('term', term).set('page', page).set('size', size)
      : new HttpParams().set('term', term).set('page', page).set('size', size).set('sort', `${sort.field},${sort.order === 1 ? 'asc' : 'desc'}`);
    return this.http.get<any>(`${this.endpoint}/filter/pageable`, { params: params });
  }

}
